/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 6/1/2023
 */
import React from "react"
import "./styles/ErrorPage403.styles.scss"
import { Fab } from "@mui/material"
import HomeIcon from "@mui/icons-material/Home"
import { useNavigate } from "react-router-dom"

const ErrorPage403 = () => {
  const navigate = useNavigate()
  const handleRedirectHome = () => {
    navigate("/app/controlPanel")
  }
  return (
    <div className="errBody">
      <div className="lock"></div>
      <div className="message">
        <h1 className="errH1">Access to this page is restricted</h1>
        <p>
          Please check with the site admin if you believe this is a mistake.
        </p>
      </div>
      <br />
      <Fab onClick={handleRedirectHome} aria-label="like">
        <HomeIcon />
      </Fab>
    </div>
  )
}

export default ErrorPage403
